import React, { useState, useEffect } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import AOS from "aos";
import "aos/dist/aos.css";
import "./FAQ.css";

const faqs = [
  {
    id: 1,
    question: "How can I donate to DEWT?",
    answer: "You can donate via bank transfer using the account details provided in our Donate section. All donations are eligible for tax exemption under Indian law.",
  },
  {
    id: 2,
    question: "Can I volunteer for your programs?",
    answer: "Yes! DEWT welcomes volunteers to participate in awareness programs, educational initiatives, relief distribution, and skill development projects. You can register through our Volunteer page.",
  },
  {
    id: 3,
    question: "Where is DEWT located?",
    answer: "DEWT's main office is registered in West Bengal, India, under registration number IV/93/2000.",
  },
  {
    id: 4,
    question: "What kind of programs does DEWT run?",
    answer: "DEWT focuses on education, women and children literacy, community leadership, disaster relief, social awareness campaigns, and youth skill development training.",
  },
  {
    id: 5,
    question: "How are donations utilized?",
    answer: "All donations are used directly to fund DEWT’s programs, including educational initiatives, relief distribution for flood and earthquake victims, women and child empowerment projects, and skill development training for youth.",
  },
];


const FAQ = () => {
  const [openId, setOpenId] = useState(null);

  useEffect(() => {
    AOS.init({ duration: 1000, once: true, easing: "ease-out-cubic" });
  }, []);

  const toggleFAQ = (id) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section className="faq-section-home" id="faq-section">
      <div className="faq-container-home">
        <h2 className="faq-title-home" data-aos="fade-up">
          Frequently Asked <span>Questions</span>
        </h2>

        <div className="faq-list-home">
          {faqs.map((faq) => (
            <div
              key={faq.id}
              className={`faq-item-home ${openId === faq.id ? "open" : ""}`}
              // Removed AOS from individual items
            >
              <div
                className="faq-question-home"
                onClick={() => toggleFAQ(faq.id)}
              >
                <span>{faq.question}</span>
                {openId === faq.id ? (
                  <FaChevronUp className="faq-icon-home" />
                ) : (
                  <FaChevronDown className="faq-icon-home" />
                )}
              </div>
              <div className="faq-answer-home">{faq.answer}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
